import { type RowData, type TableOptions } from '@tanstack/react-table';

import type { TDataTableFeatures } from '../types/features.types.js';

/**
 * Configuration hook for download of the DataTable.
 * @internal
 */
export function useDownloadData<
  TFeatures extends TDataTableFeatures,
  TData extends RowData,
>(
  props: {
    onDownloadData?: (
      subset: 'all' | 'page' | 'selected',
      excludedColumns?: string[],
    ) => void;
  },
  options: TableOptions<TFeatures, TData>,
): void {
  options.onDownloadData = props.onDownloadData;
}
